export const errorText = {
  idCard: "เลขบัตรประชาชนยังไม่ถูกต้อง",
};
